(function () {
  if (window.meta && meta.product) {
    const productContainer = document.querySelector('.product');
    const now = new Date();

    const product = {
      id: meta.product.id,
      handle: productContainer?.dataset?.productHandle,
    };

    const storedData = JSON.parse(localStorage.getItem('recentlyViewed'));

    if (storedData) {
      const lastSaved = new Date(storedData.timestamp);
      const daysSince = (now - lastSaved) / (1000 * 60 * 60 * 24);

      if (daysSince > 15) {
        localStorage.removeItem('recentlyViewed');
      }
    }

    const updatedData = JSON.parse(localStorage.getItem('recentlyViewed')) || {
      items: [],
      timestamp: now.toISOString(),
    };

    updatedData.items = updatedData.items.filter((p) => p.handle !== product.handle);
    updatedData.items.unshift(product);
    updatedData.items = updatedData.items.slice(0, 4);
    updatedData.timestamp = now.toISOString();

    localStorage.setItem('recentlyViewed', JSON.stringify(updatedData));
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const container = document.getElementById('recently-viewed-products');
    if (!container) return;

    const productGrid = container.querySelector('.product-grid');
    const viewedProducts = JSON.parse(localStorage.getItem('recentlyViewed')).items || [];

    for (let i = 0; i < viewedProducts.length; i++) {
      const product = viewedProducts[i];

      if (product.id === meta.product.id) continue;

      const productElement = document.createElement('li');
      const productData = await getProductData(product);

      const mountedElement = mountProductCard(productData, productElement);

      if (mountedElement && mountedElement.innerHTML.trim()) {
        productGrid.appendChild(mountedElement);
      }
    }

    if (productGrid.innerHTML.trim()) {
      container.classList.remove('hidden');
    }
  });
})();

async function getProductData(product) {
  const query = `
    query Product($handle: String!) {
      product(handle: $handle) {
        id
        handle
        title
        featuredImage { url }
        tags
        options {
          name
          optionValues {
            name
            swatch { color }
          }
        }
        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            selectedOptions {
              name
              value
            }
            image { url }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
          }
        }
        metafield(namespace: "custom", key: "product_variants") {
          references(first: 10) {
            nodes {
              ... on Product {
               id
        handle
        title
        featuredImage { url }
        tags
        options {
          name
          optionValues {
            name
            swatch { color }
          }
        }
        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            selectedOptions {
              name
              value
            }
            image { url }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
          }
        }
              }
            }
          }
        }
      }
    }
  `;

  try {
    const res = await fetch('https://7e-site.myshopify.com/api/2025-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '298007afa1b3b6c4a2dfdb510a09c95e',
      },
      body: JSON.stringify({ query, variables: { handle: product.handle } }),
    });

    const { data } = await res.json();
    return data;
  } catch (err) {
    console.error('Erro ao carregar produto:', err);
    return null;
  }
}

function mountProductCard(productData, productElement) {
  if (!productData || !productData.product) return null;

  const product = productData.product;
  const productFirstVariant = product?.variants?.nodes[0];
  const externalVariants = product?.metafield?.references.nodes;

  let price = '';
  let compareAtPrice = '';
  let compareAtPriceClass = '';

  price = parseFloat(productFirstVariant?.price?.amount).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  if (productFirstVariant.compareAtPrice) {
    compareAtPrice = parseFloat(productFirstVariant?.compareAtPrice?.amount).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    compareAtPriceClass = ' price--on-sale';
  }

  productElement.classList.add('grid__item');
  productElement.innerHTML = `
    <div class="card-wrapper product-card-wrapper">
      <div class="card card--media" style="--ratio-percent: 142.85714285714286%;">
        <a href="/products/${product.handle}" class="full-unstyled-link">
          <div class="card__inner ratio">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <img src="${product.featuredImage.url}" alt="${product.title}" class="motion-reduce" loading="lazy" width="608" height="839">
              </div>
              <div class="card__tags"></div>
              <div class="card__variations card__variations-colors">
                <fieldset class="js product-form__input product-form__input--swatch"></fieldset>
              </div>
            </div>
          </div>
        </a>
        <div class="card__content show-variations">
          <div class="card__information">
            <h3 class="card__heading">${product.title}</h3>
            <div class="card-information">
              <div class="price${compareAtPriceClass}">
                <div class="price__container">
                  <div class="price__regular">
                    <span class="price-item price-item--regular">${price}</span>
                  </div>
                  <div class="price__sale">
                    <s class="price-item price-item--regular">${compareAtPrice}</s>
                    <span class="price-item price-item--sale price-item--last">${price}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card__variations card__variations-sizes">
            <fieldset class="js product-form__input product-form__input--pill"></fieldset>
          </div>
        </div>
      </div>
    </div>
  `;

  mountColors(product, externalVariants, productElement.querySelector('.card__variations-colors fieldset'));
  mountSizes(product, externalVariants, productElement.querySelector('.card__variations-sizes fieldset'));
  mountTags(product, productElement.querySelector('.card__tags'));

  const form = mountForm(product, externalVariants);
  productElement.appendChild(form);

  return productElement;
}

function mountColors(product, externalVariants, container) {
  const formId = product.id.split('/Product/').pop();
  const name = `${product.handle}-Color`;
  let colors = [];
  if (externalVariants) {
    externalVariants.forEach((variante) => {
      variante.options[0].optionValues.forEach((o) => {
        colors.push(o);
      });
    });
  } else {
    colors = product.options[0].optionValues;
  }

  if (colors.length > 0) {
    colors.forEach((color, index) => {
      const id = `${product.handle}-template--recently-viewed-${index}`;
      let { imageUrl, productHandle } = getDetailsByColor(product, externalVariants, color.name);

      const html = `
      <input
        type="radio"
        id="${id}"
        name="${name}"
        value="${color.name}"
        form="product_form_${formId}"
        class="swatch-input__input swatch-input__product-card"
        data-product-variant="${productHandle}"
      >
      <img
        src="${imageUrl}"
        class="motion-reduce"
        loading="lazy"
        alt="${color.name}"
      />
      <label for="${id}" title="${color.name}" class="swatch-input__label swatch-input__label--square">
        <span class="swatch swatch--square" style="--swatch--background: ${color.swatch.color};"></span>
      </label>
    `;

      container.insertAdjacentHTML('beforeend', html);
    });
  }
}

function getDetailsByColor(product, externalVariants, colorName) {
  let variant = '';
  let handle = '';
  if (externalVariants) {
    externalVariants.forEach((externalVariant) => {
      if (externalVariant.options[0].optionValues[0].name === colorName) {
        variant = externalVariant.variants.nodes[0];
        handle = externalVariant.handle;
      }
    });
  } else {
    variant = product.variants.nodes.find((variant) =>
      variant.selectedOptions.some((option) => option.name === 'Cor' && option.value === colorName)
    );
    handle = product.handle;
  }

  return { imageUrl: variant?.image?.url, productHandle: handle } || null;
}

function mountSizes(product, externalVariants, container) {
  const formId = product.id.split('/Product/').pop();
  const color = product.options[0].optionValues[0].name;
  let sizes = [];

  if (externalVariants) {
    externalVariants.forEach((variante) => {
      variante.options[1].optionValues.forEach((sizeOption) => {
        sizes.push(sizeOption.name);
      });
      sizes = [...new Set(sizes)];
    });
  } else {
    sizes = product.options[1].optionValues.map((size) => size.name);
  }

  sizes.forEach((size) => {
    const id = `${product.handle}-size-${size}`;
    const name = `${product.handle}-Size`;

    const variant = findVariantByColorAndSize(product, color, size);
    const isAvailable = variant?.availableForSale;

    container.insertAdjacentHTML(
      'beforeend',
      `
      <input type="radio" id="${id}" name="${name}" value="${size}" form="product_form_${formId}" class="product-form__input pill-input__input sumit-on-select${
        !isAvailable ? ' disabled' : ''
      }">
      <label for="${id}" class="pill-input__label pill-input__label--square">
        ${size}
      </label>
    `
    );
  });
}

function findVariantByColorAndSize(product, color, size) {
  return product.variants.nodes.find(
    (variant) =>
      variant.selectedOptions.some((opt) => opt.name === 'Cor' && opt.value === color) &&
      variant.selectedOptions.some((opt) => opt.name === 'Tamanho' && opt.value === size)
  );
}

function mountTags(product, container) {
  (product.tags || []).forEach((tag) => {
    const tagElement = document.createElement('span');
    tagElement.className = 'card__tag';
    tagElement.textContent = tag;
    container.appendChild(tagElement);
  });
}

function mountForm(product, externalVariants) {
  const formId = product.id.split('/Product/').pop();
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/cart/add';
  form.id = `product_form_${product.handle}`;
  form.className = 'shopify-product-form';
  form.enctype = 'multipart/form-data';
  form.acceptCharset = 'UTF-8';

  form.innerHTML = `
    <input type="hidden" name="form_type" value="product">
    <input type="hidden" name="utf8" value="✓">
    <input type="hidden" name="id" value="">
    <input type="hidden" name="quantity" value="1">
    <input type="hidden" name="sections" value="cart-drawer,cart-icon-bubble">
    <input type="hidden" name="sections_url" value="/products/${product.handle}">
    <input type="hidden" name="product-id" value="${formId}">
    <input type="hidden" name="section-id" value="template--recently-viewed-products">
  `;

  const hiddenVariantsContainer = document.createElement('div');
  hiddenVariantsContainer.className = 'product-variant__options hidden';

  if (externalVariants) {
    externalVariants.forEach((externalVariant) => {
      externalVariant.variants.nodes.forEach((variant) => {
        mountHiddenVariants(variant, hiddenVariantsContainer);
      });
    });
  } else {
    product.variants.nodes.forEach((variant) => {
      mountHiddenVariants(variant, hiddenVariantsContainer);
    });
  }

  form.appendChild(hiddenVariantsContainer);
  return form;
}

function mountHiddenVariants(variant, container) {
  const variantId = variant.id.split('/ProductVariant/').pop();

  const span = document.createElement('span');
  span.id = variant.title.replace(' / ', '');
  span.dataset.variantId = variantId;
  container.appendChild(span);
}
